import { render, staticRenderFns } from "./P2PModerationWords.vue?vue&type=template&id=f561cd86&scoped=true&"
import script from "./P2PModerationWords.vue?vue&type=script&lang=js&"
export * from "./P2PModerationWords.vue?vue&type=script&lang=js&"
import style0 from "./P2PModerationWords.vue?vue&type=style&index=0&id=f561cd86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f561cd86",
  null
  
)

export default component.exports